import EventBus from '../wirebox/event-bus'
import jQuery from 'jquery'
import 'bootstrap/js/dist/modal'

class ModalComponent {

    /**
     * Construct class
    */
    constructor (players) {
        this.bindEvents()
    }
    
    /**
     * Create modal
     * @param params
    */
    create({body = '', callback = null, classes = '', closeBtn = true, contentClasses = '', footer = '', footerClasses = 'bg-light', header = '', headerClasses = 'bg-primary text-white', id = '', size = 'xl'} = {}) {
        
        //Begin HTML wrapper
        let html = `
            <div class="modal generated fade${classes ? (' ' + classes) : ''}" tabindex="-1" role="dialog" aria-hidden="true"${id ? (' id="' + id + '"') : ''}>
                <div class="modal-dialog ${size ? ('modal-' + size) : ''}">
                    <div class="modal-content${contentClasses ? (' ' + contentClasses) : ''}">
        `
        
        //Add header HTML
        if (header || closeBtn) {
            
            //Define close button HTML
            const closeBtnHtml = `
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            `
            
            html += `
                <div class="modal-header ${headerClasses ? (' ' + headerClasses) : ''}">
                    ${header}
                    ${closeBtn ? closeBtnHtml : ''}
                </div>
            `
        }
        
        //Add body HTML
        if (body) {
            html += `
                <div class="modal-body text-dark">
                    ${body}
                </div>
            `
        }
        
        //Add footer HTML
        if (footer) {
            html += `
                <div class="modal-footer${footerClasses ? (' ' + footerClasses) : ''}">
                    ${footer}
                </div>
            `
        }
        
        //End HTML wrapper
        html += `
                    </div>
                </div>
            </div>
        `
        
        //Create modal element
        const element = jQuery(html)
        
        //Add modal element to body
        jQuery('body').append(element)
        
        //Attempt callback
        if (typeof callback == 'function') {
            callback(element)
        }
        
        //Open modal
        element.modal('show')
        
    }
    
    /**
     * Modal hidden event
     * @param event
    */
    modalHidden(event) {
        
        //Get closed modal
        const element = jQuery(event.target)
        
        //Trigger destroying event on modal
        element.trigger('modal-destroying')
        
        //Remove element from body
        element.remove()
        
    }
    
    /**
     * Bind events
    */
    bindEvents () {
        
        //Bind modal creation event
        EventBus.subscribe('create-modal', this.create.bind(this))
        
        //Modal hidden
        jQuery(document).on('hidden.bs.modal', '.modal.generated', this.modalHidden.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules', () => {
    new ModalComponent()
})

export default ModalComponent